<template>
  <div class="grid gap-4 p-6">
    <!--header-->
    <div class="flex flex-col space-y-1.5 text-center sm:text-left">
      <h2
        id="radix-_r_2a_"
        class="text-lg font-semibold leading-none tracking-tight"
      >
        Manage Price Schedule
      </h2>
      <p id="radix-_r_2b_" class="text-sm text-muted-foreground">
        Configure scheduled price updates
      </p>
    </div>
    <!--form-->
    <div class="flex flex-col space-y-1.5 text-center">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label="Schedule Name" prop="name">
          <el-input v-model="form.name" placeholder="Schedule name">
            <template #prepend>
              <i class="fa fa-edit" />
            </template>
          </el-input>
        </el-form-item>
        <ProductAndESLTags ref="productAndESLTagsRef" v-model="form.items" />
        <div class="flex flex-row gap-4">
          <el-form-item class="flex-1" label="Start Time" prop="start_time">
            <el-date-picker
              v-model="form.start_time"
              type="datetime"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item class="flex-1" label="End Time" prop="end_time">
            <el-date-picker
              v-model="form.end_time"
              type="datetime"
              style="width: 100%"
            />
          </el-form-item>
        </div>
        <el-form-item label="Status" prop="status">
          <SmartSelect
            v-model="form.status"
            valueType="string"
            placeholder="Task status"
            :options="['pending', 'active', 'completed']"
            style="width: 100%"
            disabled
          />
        </el-form-item>
      </el-form>
    </div>
    <!--footer-->
    <div class="flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2">
      <el-button @click="$emit('cancel')" icon="fa fa-sign-out">
        Cancel
      </el-button>
      <el-button
        @click="handleSubmit"
        :loading="isSubmitting"
        type="primary"
        icon="fa  fa-floppy-o"
      >
        Save Schedule
      </el-button>
    </div>
    <!--close-->
    <button
      type="button"
      @click="$emit('cancel')"
      class="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground"
    >
      <i class="el-icon-close"></i>
      <span class="sr-only">Close</span>
    </button>
  </div>
</template>
<script lang="js">
import {PriceTaskModel,getEslProducts,getEslTags,createPriceTask,updatePriceTask} from "@/api";
import DateTimeRangePicker from "@/components/DateTimeRangePicker.vue";
import SmartSelect from "@/components/SmartControls/SmartSelect.vue";
import ProductAndESLTags from './ProductAndESLTags.vue'

export default {
  name: "EditTaskSchedule",
  components: { DateTimeRangePicker, SmartSelect, ProductAndESLTags },
  props: {
    value: {
      type: Object,
      default: () => new PriceTaskModel(),
    },
  },
  data(){
    return {
      form: this.value,
      isSubmitting:false,
      loading:false,
      rules: {
        name: [
          { required: true, message: 'Schedule name is required', trigger: ['blur','change'] }
        ],
        start_time: [
          { required: true, message: 'Start time is required', trigger: ['blur', 'change'] }
        ],
        end_time: [
          { 
            required: true, 
            message: 'End time is required', 
            trigger: ['blur', 'change'] 
          },
          { 
            validator: (rule, value, callback) => {
              const start = this.form.start_time;
              const end = value;
              const now = new Date();
              if (!end) {
                callback(new Error('End time is required'));
              } else if (start && end < start) {
                callback(new Error('End time cannot be earlier than start time'));
              } else if (end < now) {
                callback(new Error('End time cannot be earlier than now'));
              } else {
                callback();
              }
            }, 
            trigger: ['blur', 'change'] 
          }
        ]
      }
    }
  },
  methods:{
    getEslProducts:getEslProducts,
    getEslTags:getEslTags,
    async handleSubmit(){
      await this.$refs.form.validate()
      await this.$refs.productAndESLTagsRef.validate()
      try {
        if(this.form.id === undefined){
          await createPriceTask(this.form);
        }else{
          await updatePriceTask(this.form);
        }
        this.$emit('confirm',this.form);
      }
      catch (e) {
        if(e?.response?.data){
          this.$message.error(e.response.data);
          return;
        }
        else{
          this.$message.error("Failed to save schedule: " + e.message);
        }
      }
      finally {
        this.isSubmitting=false;
      }
    }
  }
};
</script>
